import { cn } from "@/lib/utils";

export function FiltersIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 h-2.5 text-black", className)}
      fill="none"
      viewBox="0 0 12 10"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        r="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
        transform="matrix(-1 0 0 1 2.477 2.41)"
      />
      <path
        d="M10.762 2.41H4.727"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <circle
        cx="9.523"
        cy="7.591"
        r="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M1.238 7.59h6.035"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function SearchIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3.5 text-dark-raspberry", className)}
      fill="none"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.004 12.902L10.3 10.243"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <ellipse
        cx="6.457"
        cy="6.466"
        rx="5.457"
        ry="5.368"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function SortIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 w-3.5 text-black", className)}
      fill="none"
      viewBox="0 0 14 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.20898 0.86733L0.419922 3.72085C0.275391 3.86538 0.203125 4.03725 0.203125 4.23647C0.203125 4.4435 0.267578 4.61147 0.396484 4.74038C0.529297 4.86928 0.697266 4.93374 0.900391 4.93374C1.09961 4.93374 1.26367 4.86733 1.39258 4.73452L2.52344 3.55678L3.0625 2.92983L3.02734 3.99038V10.6525C3.02734 10.8556 3.09375 11.0236 3.22656 11.1564C3.35938 11.2931 3.5293 11.3615 3.73633 11.3615C3.93555 11.3615 4.10156 11.2931 4.23438 11.1564C4.36719 11.0236 4.43359 10.8556 4.43359 10.6525V3.99038L4.39844 2.92983L4.94336 3.55678L6.06836 4.73452C6.19727 4.86733 6.36133 4.93374 6.56055 4.93374C6.76367 4.93374 6.92969 4.86928 7.05859 4.74038C7.19141 4.61147 7.25781 4.4435 7.25781 4.23647C7.25781 4.03725 7.18555 3.86538 7.04102 3.72085L4.25195 0.86733C4.11133 0.714987 3.93945 0.638815 3.73633 0.638815C3.5332 0.634909 3.35742 0.71108 3.20898 0.86733ZM10.791 11.133L13.5801 8.26772C13.7246 8.12319 13.7969 7.95327 13.7969 7.75796C13.7969 7.55092 13.7305 7.38296 13.5977 7.25405C13.4688 7.12514 13.3027 7.06069 13.0996 7.06069C12.9043 7.06069 12.7422 7.1271 12.6133 7.25991L11.4824 8.43178L10.9434 9.0646L10.9785 8.00405V1.34194C10.9785 1.13881 10.9102 0.970846 10.7734 0.838034C10.6406 0.705221 10.4746 0.638815 10.2754 0.638815C10.0723 0.638815 9.90234 0.705221 9.76562 0.838034C9.63281 0.970846 9.56641 1.13881 9.56641 1.34194V8.00405L9.60156 9.0646L9.0625 8.43178L7.93164 7.25991C7.80273 7.1271 7.64062 7.06069 7.44531 7.06069C7.23828 7.06069 7.07031 7.12514 6.94141 7.25405C6.8125 7.38296 6.74805 7.55092 6.74805 7.75796C6.74805 7.95327 6.82031 8.12319 6.96484 8.26772L9.74805 11.133C9.89648 11.2853 10.0703 11.3615 10.2695 11.3615C10.4727 11.3615 10.6465 11.2853 10.791 11.133Z"
        fill="black"
      />
    </svg>
  );
}
